import HeroSection from "../components/Training/HeroSection"
import OurConsultantsSection from "../components/Training/OurConsultantsSection"
import OurStudentsSection from "../components/Training/OurStudentsSection"
import AnimatedSection from "../components/Shared/AnimatedSection"
import Collaborations from "../components/Training/Collaborations"
const Training = () => {
    return (
        <>
        <HeroSection/>
        <AnimatedSection>
            <Collaborations/>
        </AnimatedSection>
        <AnimatedSection>
            <OurStudentsSection/>
        </AnimatedSection>
        <AnimatedSection>
            <OurConsultantsSection/>
        </AnimatedSection>
        </>
    )
}

export default Training